import { postReq } from './api';
import { DOMAIN } from '../Constants/base';
import ReactGA from 'react-ga4';

let callOnce = true;
export const postLogger = async (eventName, data) => {
  if (callOnce) {
    callOnce = false;
    let url = `${DOMAIN}/v1/events/log`;
    let payload = {
      eventName,
      data,
    };

    const response = await postReq({ url, payload });
    const { code } = response;

    if (code === 204) {
      callOnce = true;
    }
  }
};

export const trackEvents = (eventName, payload) => {
  return;
  //temp commented
  // if (process.env.REACT_APP_ENV === 'production') {
  //   ReactGA.event(eventName, payload);
  // } else {
  //   return;
  // }
};

export const setDefault = (payload) => {
  return;
  //temp commented
  // if (process.env.REACT_APP_ENV === 'production') {
  //   ReactGA.set(payload);
  // } else {
  //   return;
  // }
};
